import {Text} from 'troika-three-text'

export class TextTest {

    init(myScene) {

        for(var x=0;x<200;x++) {

            const myText = new Text()
        
            // Set properties to configure:
            myText.text = 'Hello world!'
            myText.fontSize = 0.1
            myText.position.z = 1
            
            myText.position.x = Math.random() * 4 - 1
            myText.position.y = Math.random() * 4 - 1

            myText.color = Math.random() * 400

            myScene.add(myText)

            myText.sync()

        }

        
    }
}